import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    lineHeight: 1.8,
  },
}));

const StyledTypography = ({ children, classes, ...other }) => {
  const componentClasses = useStyles({ classes });
  return (
    <Typography classes={componentClasses} {...other}>
      {children}
    </Typography>
  );
};

export default StyledTypography;
